import React from 'react';
import SignupSchoolScreen from './SignupDrilldownScreen';

export default (props: any) => <SignupSchoolScreen {...props} />;

